/**
 * TocTree (= Table Of Contents Tree) builds a tree structure out of passed heading elements.
 *
 */
export const DOC_START_ID = "#doc-start";
export var TocTree;
(function (TocTree) {
  TocTree.buildTree = (headlineElements, ignoreH1 = true) => {
    const headlineInfos = parseHeadlines(headlineElements);
    const rootNode = {
      children: [],
      name: "root",
      id: "root",
      element: null,
      level: 0
    };
    const tree = rootNode.children;
    let prevNode;
    headlineInfos.forEach((entry, i) => {
      const isFirst = i === 0;
      entry.children = [];
      if (isFirst) {
        rootNode.children.push(entry);
      } else {
        // position incoming headline in current/deeper/shallower level.
        if (prevNode.level === entry.level) {
          findParentNode(prevNode, rootNode).children.push(entry);
        } else if (entry.level > prevNode.level) {
          prevNode.children.push(entry);
        } else {
          findParentNodeWithLevelLower(prevNode, entry.level, rootNode).children.push(entry);
        }
      }
      prevNode = entry;
    });
    if (ignoreH1) {
      const firstLevelIsH1 = tree.length === 1 && tree[0].element.tagName.toLowerCase() === 'h1';
      if (firstLevelIsH1) return tree[0].children;else return tree || [];
    } else {
      return tree || [];
    }
  };
  TocTree.prependIntroductionTreeNode = tree => {
    const item = {
      label: "Einleitung",
      data: DOC_START_ID,
      selectable: true,
      // icon:'file',
      // styleClass:e.type==='f'?'node-file':'node-folder',
      expanded: true
    };
    return [item, ...tree];
  };
  TocTree.toTreeNodes = tree => {
    return tree.map(e => {
      const item = {
        label: e.name,
        data: e.id,
        selectable: true,
        // icon:'file',
        // styleClass:e.type==='f'?'node-file':'node-folder',
        expanded: true
      };
      if (e.children) {
        item.children = TocTree.toTreeNodes(e.children);
      }
      return item;
    });
  };
  const parseHeadlines = headlineElements => {
    return headlineElements.reduce((collection, element) => {
      if (!/h[0-6]/.exec(element.tagName.toLowerCase())) {
        throw new Error('only headline HTMLElements must be passed to TocTree builder');
      }
      if (element.id) {
        const entry = {
          level: parseInt(element.tagName.slice(1), 10),
          name: element.innerText || element.textContent,
          id: element.id,
          element
        };
        collection.push(entry);
      }
      return collection;
    }, []);
  };
  const findParentNode = (needle, haystack) => {
    if (haystack.children.indexOf(needle) !== -1) {
      return haystack;
    }
    let parent;
    let i = haystack.children.length;
    while (i--) {
      parent = findParentNode(needle, haystack.children[i]);
      if (parent) return parent;
    }
    return null;
  };
  const findParentNodeWithLevelLower = (needle, level, haystack) => {
    const parent = findParentNode(needle, haystack);
    if (!parent) {
      return null;
    } else if (parent.level < level) {
      return parent;
    } else {
      return findParentNodeWithLevelLower(parent, level, haystack);
    }
  };
})(TocTree || (TocTree = {}));